module.exports = __webpack_public_path__ + "static/media/citrus-hosted-poll.bb9f6108.webp";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/citrus-hosted-poll.webp
// module id = 253
// module chunks = 1